// extracted by mini-css-extract-plugin
export default {"LogoClasse":"Logo_LogoClasse__vGxSx","imageLogo":"Logo_imageLogo__55z5m"};